var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseInput',{attrs:{"placeholder":"https://example.com"},model:{value:(_vm.target[_vm.type]),callback:function ($$v) {_vm.$set(_vm.target, _vm.type, $$v)},expression:"target[type]"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }